<template>
    <TableView :heading="`${__('Teacher')} ${__('Designation')}`"
        :headers="[
            { name: __('Designations'), value: (row) => locale_attr(row, 'designation_{lang}_name') },
            { name: __('Teacher'), value: (row) => en_to_bn(row.user_count) }
        ]"
        :rows="designations"
        :pagination="pagination"
        :loading="loading"
        @change:page="fetchCounts" />
</template>

<script>
import axios from 'axios';
import TableView from './TableView.vue';

export default {
    components: {
        TableView,
    },

    inject: ['selectedStatsWheelPath'],

    data() {
        return {
            designations: [],
            pagination: {
                current_page: 1,
                last_page: 1,
                per_page: 10,
                total: 0,
                from: 0,
                to: 0,
            },
            loading: false,
        }
    },

    watch: {
        selectedStatsWheelPath: function (value) {
            if (['Teacher', 'Ambassador'].includes(value)) {
                this.fetchCounts();
            }
        },
    },

    mounted() {
        this.observe_visibility(this.$el, () => this.fetchCounts());
    },

    methods: {
        fetchCounts(args = {}) {
            this.loading = true;
            const params = {
                page: this.pagination.current_page,
                ambassador: this.selectedStatsWheelPath === 'Ambassador',
                ...args,
            };
            axios.get('/dashboard/designation-wise-user-count', { params })
                .then(({ data }) => {
                    this.designations = data.counts.collection;
                    this.pagination = data.counts.pagination;
                })
                .catch(console.error)
                .finally(() => this.loading = false);
        },
    },
}
</script>